export default function PageHeader({ title, subtitle, icon: Icon, actions, testId }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-4 mb-8 pgp-fade-up" data-testid={testId}>
      <div className="flex items-start gap-4">
        {Icon && (
          <div className="h-11 w-11 rounded-xl bg-amber-500/12 border border-amber-500/25 flex items-center justify-center mt-0.5">
            <Icon className="h-5 w-5 text-amber-400" />
          </div>
        )}
        <div>
          <h1 className="text-2xl sm:text-3xl font-head font-extrabold tracking-tight text-slate-50">{title}</h1>
          {subtitle && <p className="text-sm text-slate-400 mt-1 max-w-2xl">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
